<template>
	<div
		class=""
		style="background-color: #2266cc">
		<div
			class="pt-6"
			style="">
			<div style="width: 100%">
				<div
					class="has-text-centered columns mt-1 mb-3 is-centered is-vcentered is-multiline">
					<div
						class="column is-9 mb-1 px-5-mobile"
						style="text-shadow: #000 0px 0px 3px">
						<div class="">
							<div class="field has-addons">
								<div class="control is-expanded">
									<input
										ref="search-bar"
										@keyup.enter="search"
										autocomplete="off"
										class="input is-rounded pl-4 is-size-6"
										type="text"
										value=""
										placeholder="I'm searching for..." />
								</div>
								<div
									class="control"
									style="opacity: 1">
									<button
										class="button is-rounded is-info is-size-6"
										:class="{ 'is-loading': isSearching }"
										@click="search"
										type="submit">
										<a
											class="has-text-weight-bold has-text-white is-hidden-mobile"
											>Search</a
										>
										<span class="has-text-white"
											>&nbsp;&nbsp;<i class="fas fa-search"></i
											>&nbsp;&nbsp;</span
										>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="">
			<div
				class="tabs is-centered is-boxed"
				style="">
				<ul>
					<li
						data-view="overview"
						:class="{ 'is-active': tab == 'overview' ? true : false }"
						@click="setTab('overview')">
						<a class="has-text-white is-size-6"
							><span class="icon"
								><i
									class="fas fa-search"
									aria-hidden="true"></i></span
							><span>Overview</span></a
						>
					</li>
					<li
						data-view="products"
						:class="{ 'is-active': tab == 'products' ? true : false }"
						@click="setTab('products')">
						<a class="has-text-white is-size-6"
							><span class="icon"
								><i
									class="fas fa-gifts"
									aria-hidden="true"></i></span
							><span>Products</span></a
						>
					</li>
					<li
						data-view="shops"
						:class="{ 'is-active': tab == 'shops' ? true : false }"
						@click="setTab('shops')">
						<a class="has-text-white is-size-6"
							><span class="icon"
								><i
									class="fas fa-store"
									aria-hidden="true"></i></span
							><span>Shops</span></a
						>
					</li>
					<li
						data-view="reviews"
						class="comming-soon"
						:class="{ 'is-active': tab == 'reviews' ? true : false }"
						@click="setTab('reviews')">
						<a class="has-text-white is-size-6"
							><span class="icon"
								><i
									class="fas fa-film"
									aria-hidden="true"></i></span
							><span>Reviews</span></a
						>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<style type="text/css" scoped>
	.comming-soon {
		display: none;
	}
	.tabs.is-boxed li a:hover {
		color: rgba(255, 255, 255, 0.6);
		background-color: transparent;
	}

	.tabs.is-boxed li.is-active a {
		background-color: #fff;
		cursor: pointer;
	}

	.tabs.is-boxed li {
		cursor: pointer;
	}

	.tabs.is-boxed li a {
		opacity: 1;
		cursor: pointer;
	}

	.tabs.is-boxed li.is-active a span {
		color: #2e323a; /*A Dark Color*/
	}
</style>
<script type="text/javascript">
	import axios from "axios";
	axios.defaults.headers.post["X-CSRF-TOKEN"] = window.csrf_token;

	export default {
		props: ["search_link", "query"],
		data() {
			return {
				tab: null,
				isTyping: false,
				isSearching: false,
				lastSearchTerm: null,
			};
		},
		mounted() {
			this.setTab("overview");
			this.$refs["search-bar"].value = this.$props.query;
			this.search();
		},
		methods: {
			setTabElement(event) {
				this.setTab(event.target.getAttribute("data-view"));
				console.log(event);
			},
			setTab(value) {
				this.tab = value;
			},
			productsPromise() {
				let _this = this;
				return axios.post(_this.search_link, {
					query: _this.$refs["search-bar"].value,
					type: "products",
				});
			},
			shopPromise() {
				let _this = this;
				return axios.post(_this.search_link, {
					query: _this.$refs["search-bar"].value,
					type: "shops",
				});
			},
			productsAndShopsPromise() {
				let _this = this;
				return axios.post(_this.search_link, {
					query: _this.$refs["search-bar"].value,
					type: "products_and_shops",
				});
			},
			productsAndShopsPagination(response) {
				this.$store.dispatch("set_products", response.data[0]);
				this.$store.dispatch("set_shops", response.data[1]);
			},
			search() {
				let _this = this;
				this.$store.dispatch(
					"set_search_term",
					_this.$refs["search-bar"].value
				);

				let searchTerm = _this.$store.getters.searchTerm;
				// Guard to ensure that if there is no new search term then don't make a search request.
				if (this.lastSearchTerm === searchTerm) {
					return; /* Nothing to search */
				}

				_this.$store.dispatch("set_is_searching", true);
				this.productsAndShopsPromise()
					.then(function (response) {
						_this.$store.dispatch("clear_search");
						_this.productsAndShopsPagination(response);
					})
					.catch(function (error) {})
					.then(function (response) {
						_this.$store.dispatch("set_is_searching", false);
						_this.lastSearchTerm = searchTerm;
					});
			},
			typing() {
				let _this = this;
				this.isTyping = true;
				setTimeout(function () {
					_this.isTyping = false;
				}, 200);
				setTimeout(function () {
					if (_this.isSearching != true && !_this.isTyping) {
						_this.search();
					}
				}, 700);
			},
		},
		watch: {
			state: {
				deep: true,
				handler(newValue, oldValue) {
					this.isSearching = this.$store.getters.isSearching;
				},
			},
			tab: {
				handler(newValue, oldValue) {
					this.$store.dispatch("set_market_tab", newValue);
				},
			},
		},
	};
</script>
